// extracted by mini-css-extract-plugin
export default {"total":"Rewards_total__dLuZ9","number":"Rewards_number__cDfoz","small":"Rewards_small__qPgCp"};